<template>
  <div class="divider"></div>
</template>

<script>
export default {
  name: 'BDivider',
}
</script>

<style lang="scss" scoped>
  @import "../styles/variables";

  .divider {
    min-height: 5px;
    width: 50px;
    background-color: $orange;
    margin-right: auto;
    margin-left: auto;
  }
</style>
